import { useCanDoLevelWrites } from "../../entities/helpers/authorization";

export function useCanCreateNewCmaxUser(): boolean {
  return useCanDoLevelWrites(2);
}
